import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import VisitorsReportLayer from "../components/VisitorsReportLayer";

const VisitorsReportPage = () => {
    return (
        <MasterLayout>
            <VisitorsReportLayer />
        </MasterLayout>
    );
};

export default VisitorsReportPage;
